import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { space } from '@synoptic/ui-kit/tokens.js';
import { typography } from '@synoptic/ui-kit/typography.js';
import { style, styleVariants } from '@vanilla-extract/css';

export const editorContainer = style({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
});

const basePlaceholder = style([
  typography['bodyLg'],
  {
    color: themeVars.container.foreground.tertiary,
    overflow: 'hidden',
    position: 'absolute',
    textOverflow: 'ellipsis',
    top: 0,
    left: 0,
    userSelect: 'none',
    pointerEvents: 'none',
    padding: 'inherit',
  },
]);

export const editorPlaceholder = styleVariants({
  base: [basePlaceholder],
  textarea: [
    basePlaceholder,
    {
      padding: `${space.s12}px ${space.s16}px`,
    },
  ],
  small: [basePlaceholder, typography['bodyMd']],
});

export const editorContentEditableContainer = style({
  flexGrow: 1,
  position: 'relative',
});
